import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export function disabledAliasesPageGuard(pageKey: string): CanActivateFn {
  return async (route) => {
    const { disabledAliases = [] } = route.data;
    const { alias = '' } = route.params;
    const router = inject(Router);

    if (disabledAliases.includes(alias)) {
      return router.createUrlTree(['/disabled', pageKey]);
    }

    return true;
  };
}
